/**
 * DARE Vanguard — Deferred Script Loader
 * Extracted from theme.liquid inline script (lines 492-619)
 * Loaded via <script defer> from theme.liquid
 * Requires window.__DARE_CFG to be set synchronously before this script executes.
 */
(function() {
  'use strict';

  // Config is expected to be set on window.__DARE_CFG before this script runs
  var cfg = window.__DARE_CFG || {};

  var scriptsLoaded = false;
  var scriptQueue = [];
  var setupActions = [];

  function enqueueScript(src) {
    scriptQueue.push(src);
  }

  function enqueueAction(fn) {
    setupActions.push(fn);
  }

  function loadNextScript() {
    if (scriptQueue.length === 0) return;
    var item = scriptQueue.shift();
    var s = document.createElement('script');
    if (typeof item === 'object') {
      s.src = item.src;
      if (item.module) { s.type = 'module'; s.crossOrigin = 'anonymous'; }
    } else {
      s.src = item;
    }
    s.onload = loadNextScript;
    s.onerror = loadNextScript;
    document.body.appendChild(s);
  }

  function loadDeferredScripts() {
    if (scriptsLoaded) return;
    scriptsLoaded = true;
    setupActions.forEach(function(fn) { fn(); });
    loadNextScript();
  }

  function scheduleDeferredScripts() {
    function run() { loadDeferredScripts(); }
    if (document.readyState === 'complete') {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(run, { timeout: 4000 });
      } else {
        setTimeout(run, 2000);
      }
      return;
    }
    window.addEventListener('load', function() {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(run, { timeout: 4000 });
      } else {
        setTimeout(run, 2000);
      }
    }, { once: true });
  }

  // Chat widget action — uses cfg.chat
  if (cfg.chat) {
    enqueueAction(function() {
      var chat = document.createElement('shopify-chat');
      var attrs = cfg.chat;
      for (var key in attrs) {
        chat.setAttribute(key, attrs[key]);
      }
      document.body.appendChild(chat);
    });
  }

  // Geo/currency scripts on non-product pages
  if (cfg.geoRestrictionUrl) {
    enqueueScript(cfg.geoRestrictionUrl);
  }
  if (cfg.currencyLocalizationUrl) {
    enqueueScript(cfg.currencyLocalizationUrl);
  }

  // Inbox chat widget (always enqueued if URL provided)
  if (cfg.inboxChatUrl) {
    enqueueScript(cfg.inboxChatUrl);
  }

  // Forms deferred loading logic
  enqueueAction(function() {
    function isFormsAsset(src) {
      if (!src) return false;
      return src.indexOf('shopify-forms') !== -1 ||
        (src.indexOf('cdn.shopify.com/extensions/') !== -1 && src.indexOf('/forms-') !== -1);
    }

    function loadDeferredElement(el) {
      var src = el.getAttribute('data-deferred-src');
      if (!src) return;
      var s = document.createElement('script');
      s.src = src;
      if (el.getAttribute('type') === 'module') {
        s.type = 'module';
        s.crossOrigin = 'anonymous';
      }
      document.body.appendChild(s);
    }

    var formsDeferredEls = [];
    var els = document.querySelectorAll('[data-deferred-src]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var src = el.getAttribute('data-deferred-src');
      if (!src) continue;
      if (isFormsAsset(src)) {
        formsDeferredEls.push(el);
        continue;
      }
      if (el.getAttribute('type') === 'module') {
        // Use the enqueueScript with object for module scripts
        var item = { src: src, module: true };
        // Reuse enqueueScript logic for module
        var s = document.createElement('script');
        s.src = src;
        s.type = 'module';
        s.crossOrigin = 'anonymous';
        s.onload = function() { /* next will be called by loadNextScript */ };
        s.onerror = function() { /* same */ };
        document.body.appendChild(s);
      } else {
        enqueueScript(src);
      }
    }

    if (formsDeferredEls.length === 0) return;

    var formsTarget = document.querySelector('[data-shopify-forms], .shopify-block--shopify--apps--forms, .shopify-section--apps');
    if (!formsTarget) return;

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          obs.disconnect();
          formsDeferredEls.forEach(function(el) {
            var src = el.getAttribute('data-deferred-src');
            if (!src) return;
            var s = document.createElement('script');
            s.src = src;
            if (el.getAttribute('type') === 'module') {
              s.type = 'module';
              s.crossOrigin = 'anonymous';
            }
            document.body.appendChild(s);
          });
        });
      }, { rootMargin: '200px' });
      // Find the actual forms target element
      var target = document.querySelector('[data-shopify-forms], .shopify-block--shopify--apps--forms, .shopify-section--apps');
      if (target) {
        obs.observe(target);
      }
    } else {
      formsDeferredEls.forEach(function(el) {
        var src = el.getAttribute('data-deferred-src');
        if (!src) return;
        var s = document.createElement('script');
        s.src = src;
        if (el.getAttribute('type') === 'module') {
          s.type = 'module';
          s.crossOrigin = 'anonymous';
        }
        document.body.appendChild(s);
      });
    }
  });

  // Schedule deferred loading
  if (document.readyState === 'complete') {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function() { loadDeferredScripts(); }, { timeout: 4000 });
    } else {
      setTimeout(function() { loadDeferredScripts(); }, 2000);
    }
  } else {
    window.addEventListener('load', function() {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(function() { loadDeferredScripts(); }, { timeout: 4000 });
      } else {
        setTimeout(function() { loadDeferredScripts(); }, 2000);
      }
    }, { once: true });
  }
})();